import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=93b47e42"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports